module.exports = __webpack_public_path__ + "img/0Q3A6078_L_Foamcore_MockedUp.01ad3d6c.jpg";